import { useState, useEffect } from "react";
import { gql, useQuery } from "@apollo/client";

const GET_ISSUE_PREVIEW = gql`
  query GetIssue($id: ID!, $isSlug: Boolean!) {
    issue(id: $id, isSlug: $isSlug) {
      id
      name
      slug
      description
      cover
      data
      updated
      externalUrl
    }
  }
`;

export function usePreview(issueId) {
  const [issue, setIssue] = useState(null);
  const { loading, error, data } = useQuery(GET_ISSUE_PREVIEW, {
    variables: { id: issueId, isSlug: isNaN(issueId) },
  });

  useEffect(() => {
    if (!data) {
      return;
    }
    const i = JSON.parse(JSON.stringify(data.issue));
    delete i.__typename;
    setIssue(i);
  }, [data]);

  return {
    isLoading: loading,
    error,
    issue,
  };
}